// jquery lib
import '../../../assets/js/vendor/jQuery1.9.1.min';
import '../../../../../modules/system/assets/js/framework';

// libs
import '../../../assets/js/vendor/jquery-ui.min1.9.2';
import '../../../assets/js/vendor/jquery.mask.min';

/* different functions for all project */
import './js/helpers';
import './pagination/pagination';
import 'slick-carousel';

/* Tabs */
import {Tabs} from './tabs/tabs';

// modules
import './form/form';
import './news-card/news-card';
import './sorting/sorting';
import './modal-promo/modal-promo';
import './modal-subscription/modal-subscription';
import './modal-subscription/modal-order';
import './search-bar/search-bar';
import './promo-input-block/promo-input-block';
import './show-more/ShowMore';
import './blockquote-author/blockquote-author';
import './subscription-block/subscription-block';
import './modal-unavailability-etalon/modal-unavailability-etalon';
import './comments-icon/comments-icon';
import './paid-video/paid-video';
import './articles/articles';
import './article/article-view-counter';
import './modal-journal-content/modal-journal-content';
import './journal/by-one-article';
import './modal-authorization-registration/auth_reg';
import './christmas/snow';
import './christmas/balls';
import './subscription-versions/subscription-versions';
import './expired-subs/expired-subs'
import './favorites/favorites'
import './likes/likes';
import './modal-cookie/modal-cookie';

import './etalonline-link/etalonline-link';

import './subscription-versions/subscription-versions';
import './subscription-select/subscription-select-custom';
import './subscription-versions/subscription-table';
import './personal-cart/personal-cart-promocode';
import './auth-controller/auth-controller'

import './bookmarks/bookmarks';
import './form-doc/form_doc';
import './time-on-page-counter/time-on-page-counter';
import './comments/comments';



const activeLinkClass = '_active-link';
const activeClass = '_active';

/* Tariff tabs */
const tariffTab = new Tabs({
  initTabs: 'tariff-tab',
  tab: 'tariff-tab__pane',
  tabActive: activeClass,
  tabLink: 'tariff-tab__item',
  tabLinkActive: activeLinkClass,
});

// init tariff tab content on 6 month
tariffTab.setActiveTab('6-month');

/* eslint-disable no-new */
// TODO remove Tabs created with new

/* Subscription tabs */
new Tabs({
  initTabs: 'subscription__body',
  tab: 'subscription__body-pane',
  tabActive: activeClass,
  tabLink: 'subscription__body-tabs-item',
  tabLinkActive: activeLinkClass,
});
/* Contact-managers page tabs */
new Tabs({
  initTabs: 'contacts-managers',
  tab: 'contacts-managers__tab',
  tabActive: activeClass,
  tabLink: 'contacts-managers__tab-controls-item',
  tabLinkActive: activeLinkClass,
});
/* eslint-enable no-new */

/* Index page gallery */
$('.gallery').slick({
  draggable: false,
  slidesToShow: 2,
  infinite: true,
  slidesToScrol1: 1,
  autoplay: true,
  autoplaySpeed: 0,
  arrows: false,
  speed: 3000,
  easing: 'linear',
  variableWidth: true,
  pauseOnHover: true,
  slide: '.slider .group',
  swipeToSlide: true,
});

